import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import Dropdown from 'flarum/common/components/Dropdown';
import Link from 'flarum/common/components/Link';

// Discussion ids for the 2 "Divers" menu entries that are plain articles
// rather than glossary/books/links content - same two discussions
// ("Hommage à Christian Frund", "Références lichens") found directly on
// champis.net's own "Divers" menu, reusing champis-articles' existing
// /article/:id page rather than building a second way to render a plain
// discussion. app.route('article', ...) is a runtime lookup, not a
// build-time import, so this doesn't create an actual dependency on
// champis-articles - same soft coupling as champis-species' own menu.
const HOMMAGE_DISCUSSION_ID = 1025846;
const LICHENS_REFERENCES_DISCUSSION_ID = 1028322;
// Data behind the menu's own render below - one entry per
// .ChampisForumsMenu-group section, in champis.net's own "Divers" menu
// order (see addOthersMenu()'s own docblock). Kept as a plain array rather
// than the 14 near-identical hand-written <Link> blocks this replaced, so
// adding/reordering an entry is a one-line data change instead of copying
// a whole JSX block.
const MENU_GROUPS = [{
  labelKey: 'christian_frund_group',
  items: [{
    labelKey: 'hommage_link',
    route: 'article',
    params: {
      id: HOMMAGE_DISCUSSION_ID
    }
  }]
}, {
  labelKey: 'glossary_group',
  items: [{
    labelKey: 'glossary_link',
    route: 'glossary'
  }]
}, {
  labelKey: 'books_group',
  items: [{
    labelKey: 'books_field_link',
    route: 'books',
    params: {
      category: 'field'
    }
  }, {
    labelKey: 'books_reference_link',
    route: 'books',
    params: {
      category: 'reference'
    }
  }, {
    labelKey: 'books_mycology_link',
    route: 'books',
    params: {
      category: 'mycology'
    }
  }]
}, {
  labelKey: 'references_group',
  items: [{
    labelKey: 'lichens_references_link',
    route: 'article',
    params: {
      id: LICHENS_REFERENCES_DISCUSSION_ID
    }
  }]
}, {
  labelKey: 'links_group',
  items: [{
    labelKey: 'links_generalwebsites_link',
    route: 'links',
    params: {
      category: 'generalwebsites'
    }
  }, {
    labelKey: 'links_ascomycota_link',
    route: 'links',
    params: {
      category: 'ascomycota'
    }
  }, {
    labelKey: 'links_basidiomycota_link',
    route: 'links',
    params: {
      category: 'basidiomycota'
    }
  }, {
    labelKey: 'links_frenchsocieties_link',
    route: 'links',
    params: {
      category: 'frenchsocieties'
    }
  }, {
    labelKey: 'links_swisssocieties_link',
    route: 'links',
    params: {
      category: 'swisssocieties'
    }
  }, {
    labelKey: 'links_belgiansocieties_link',
    route: 'links',
    params: {
      category: 'belgiansocieties'
    }
  }, {
    labelKey: 'links_canadiansocieties_link',
    route: 'links',
    params: {
      category: 'canadiansocieties'
    }
  }, {
    labelKey: 'links_various_link',
    route: 'links',
    params: {
      category: 'various'
    }
  }]
},
// Not part of champis.net's own "Divers" menu (this is a new page,
// nothing there to mirror) - its own group at the end so it doesn't
// disturb the reference-matching order of every group above it.
{
  labelKey: 'stats_group',
  items: [{
    labelKey: 'stats_link',
    route: 'stats'
  }]
}];
function menuLabel(key) {
  return app.translator.trans(`champis-others.forum.others_menu.${key}`);
}

// Adds a "Divers" dropdown to the header, right after champis-forum's
// 'forumsMenu' (85) - matching champis.net's own top nav order (Accueil,
// Espèces, Articles, Forum, Divers). All 14 entries are static (unlike
// champis-articles' own dynamic menu, this list doesn't change without a
// code change - matches how champis.net's reference menu is hand-built
// too), so this needs no data loading of its own.
//
// Grouped under 5 section headers (Christian Frund / Glossaire / Livres /
// Références / Liens), matching champis.net's own "Divers" menu structure
// - each a <span className="ChampisForumsMenu-group">, the exact same
// non-interactive group-header markup addForumsMenu.js uses for its own
// primary-tag headers (see that file), so this picks up the identical
// bold/uppercase label + divider-line-before-every-group-but-the-first
// styling for free (forum.less' .ChampisForumsMenu-group rules aren't
// scoped to that menu specifically).
export default function addOthersMenu() {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    items.add('othersMenu', m(Dropdown, {
      buttonClassName: "Button Button--link",
      menuClassName: "ChampisForumsMenu-menu",
      label: menuLabel('label'),
      accessibleToggleLabel: menuLabel('toggle_accessible_label')
    }, MENU_GROUPS.map(group => [m("span", {
      className: "ChampisForumsMenu-group"
    }, menuLabel(group.labelKey)), group.items.map(item =>
    // app.route()'s param-extraction mutates (deletes from) the
    // object it's given, so item.params - a stable reference
    // shared across every redraw via the module-level MENU_GROUPS
    // - must be spread into a fresh object on each call, or the
    // param survives only the first render.
    m(Link, {
      className: "ChampisForumsMenu-item",
      href: app.route(item.route, {
        ...item.params
      })
    }, menuLabel(item.labelKey)))])), 80);
  });
}